import * as React from "react";
import { Link } from 'react-router-dom';

import { Paper, Grid }  from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar';
import PeopleIcon from '@material-ui/icons/People';
import StoreMallDirectoryIcon from '@material-ui/icons/StoreMallDirectory';
import BusinessIcon from '@material-ui/icons/Business';
import CollectionsIcon from '@material-ui/icons/Collections';
import SettingsIcon from '@material-ui/icons/Settings';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import TimelineIcon from '@material-ui/icons/Timeline';
import InputIcon from '@material-ui/icons/Input';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';
import InfoOutlined from '@material-ui/icons/Info';


import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import "./AdministrationMenu.scss";
import { CloudUpload } from "@material-ui/icons";

// tslint:disable-next-line:no-empty-interface
export interface IAdministrationMenuProps {
    paramIcon: any
}

export interface IAdministrationMenuState {
    anchorEl?: HTMLElement;
    openRegister: boolean;
}

interface IListItemProps {
    icon: React.ReactNode;
    link: string;
    title: string;
    paths?: string[];
}

export class AdministrationMenu extends React.Component<IAdministrationMenuProps, IAdministrationMenuState> {

    constructor(props: IAdministrationMenuProps) {
        super(props);

        this.state = {
            anchorEl: undefined,
            openRegister: false
        };
    }

    public menuBarListItems = () => {
        const menuBarListItems: IListItemProps[] = [
            {icon: <PermContactCalendarIcon />, link: '/administration/accessreport', title: 'Acessos'},
            {icon: <PeopleIcon />, link: '', title: 'Cadastros', paths: ['/administration/users-register', '/administration/bookstores-register']},
            {icon: <VpnKeyIcon />, link: '/administration/permission', title: 'Permissões'},
            {icon: <TimelineIcon />, link: '/administration/analytics', title: 'Analytics',},
            {icon: <InputIcon />, link: '/administration/dataLoad', title: 'Carga de Dados',},
            {icon: <PriorityHighIcon />, link: '/administration/alerta', title: 'Dados Atrasados',},
            {icon: <InfoOutlined />, link: '/administration/informacoesSellout', title: 'Informações Sellout',},
        ];
        return menuBarListItems;
    }

    public cadastrosMenuListItems = () => {
        const cadastrosMenuListItems: IListItemProps[] = [
            {icon: <PeopleIcon />, link: '/administration/users-register', title: 'Usuários'},
            {icon: <StoreMallDirectoryIcon />, link: '/administration/bookstores-register', title: 'Livrarias'},
            {icon: <BusinessIcon />, link: '/administration/publishers-register', title: 'Editoras'},
            {icon: <CollectionsIcon />, link: '/administration/product-group-register', title: 'Agrupamento Produtos'},
            {icon: <SettingsIcon />, link: '/administration/product-category-correction', title: 'Correção de Categorias de Produtos'},
            {icon: <RemoveCircleOutlineIcon />, link: '/administration/product-blacklist', title: 'Blacklist de Produtos'},
            {icon: <CollectionsIcon />, link: '/administration/product-grid', title: 'Listagem Produtos'},
            {icon: <StoreMallDirectoryIcon />, link: '/administration/editora-fabricante', title: 'Editoras BookinfoXSimpleset'},
            {icon: <CloudUpload />, link: '/administration/product-import-sell-out', title: 'Importação Sell Out'},
            {icon: <CollectionsIcon />, link: '/administration/unidentified-products-list', title: 'Produtos Não Identificados'},
            {icon: <CollectionsIcon />, link: '/administration/product-group-new-register', title: 'Agrupamento Produtos V2'}

        ];
        return cadastrosMenuListItems;
    }
    
    public render() {

        const { anchorEl } = this.state;
        return (
            <div className="wrapper">
                <Grid
                  container={true}
                  className="administration-menu-panel panel-grid"
                  spacing={16}>

                    <Grid item={true} xs={12} md={12} sm={12}>
                        <Paper>
                            <div className="menu-bar administrationMenu">
                                <List component="nav">
                                    {this.getCadastrosMenuListItem(anchorEl)}
                                    {this.getListItem()}    
                                </List>
                            </div>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        );
    }

    public handleRegisterClick = (event: React.MouseEvent<HTMLElement>) => {
        this.setState({ openRegister: !this.state.openRegister });
        this.setState({ anchorEl: event.currentTarget });
    };

    public handleRegisterMenuClose = () => {
        this.setState({ openRegister: false });
        this.setState({ anchorEl: undefined });
    };

    private getListItem = () => {
        const list = this.menuBarListItems();
        return list.map(v => {return v.title !== 'Cadastros' ? (
            <ListItem key={v.title} button={true} className={'menuBarItem ' + this.getItemClassName(v.link, v.paths)}>
                <Link to={v.link} className="link-bar">
                    <ListItemIcon><>{v.icon}</></ListItemIcon>
                    <ListItemText primary={v.title} />
                </Link>
            </ListItem>
        ) : this.getCadastrosBarItem(v);});
    }

    private getCadastrosBarItem = (v: IListItemProps) => {
        return (
        <ListItem key={v.title} button={true} onClick={this.handleRegisterClick}
            className={'menuBarItem ' + this.getItemClassName(v.link, v.paths)}>
            <ListItemIcon><>{v.icon}</></ListItemIcon>
            <ListItemText primary={v.title} />
            {(this.state.openRegister ? <ExpandLess /> : <ExpandMore />)}
        </ListItem>
        );
    }

    private getCadastrosMenuListItem = (anchorEl?: HTMLElement) => {
        const list = this.cadastrosMenuListItems();
        return (<Menu className="register-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={this.handleRegisterMenuClose}>
            {list.map(v => {return (
            <MenuItem key={v.title} onClick={this.handleRegisterMenuClose} className={this.getItemClassName(v.link)}>
                <Link to={v.link} className="link-bar">
                    <div>{v.icon}</div>
                    {v.title}
                </Link>
            </MenuItem>)})}
        </Menu>);
    }

    private getItemClassName = (path?: string, paths?: string[]) => {
        if (!!paths) {
            return paths.includes(window.location.pathname) ? "selectedItemBackground" : "";
        }
        if (!!path) {
            return path === '/administration/accessreport' ? 'access' : path === window.location.pathname ? "selectedItemBackground" : "";
        }
        return "";
    }
}



// WEBPACK FOOTER //
// ./src/component/administration/shared/menu/AdministrationMenu.tsx